import util from '../util'

let controller = 'v1/ParceiroCallbackAntifraude'

export default Object.assign({}, util.GetCrud(controller, ['get', 'post']))
